import {ApiClient} from '@hconnect/apiclient'
import {OrderByApiProperty, ApiFilter} from '@hconnect/common/maintain-filters'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'

export const QueryKey = 'tasks-master-list-export'

type TasksExportVariables = {
  page: number
  filters?: ApiFilter[]
  order?: OrderByApiProperty[]
}

export const useTasksListExport = () => {
  return useMutation({
    mutationFn: async ({page, filters, order}: TasksExportVariables) => {
      const path = '/rootcausefailureanalysis/analyses/tasks/excel'
      const {data} = await ApiClient.axiosInstance.post(
        path,
        {pageNumber: page, filters, orderBy: order},
        {
          responseType: 'arraybuffer'
        }
      )

      return new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
    },
    onError: () => spawnErrorToast('Failed to generate excel export', {closeOnClick: true})
  })
}
